import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useLegalConfig } from "../components/LegalPageShell";

export default function ContactPage() {
  const { t } = useLanguage();
  const cfg = useLegalConfig();

  return (
    <div data-testid="contact-page" className="min-h-screen bg-white px-4 sm:px-6 py-8 max-w-2xl mx-auto">
      <Link to="/" data-testid="contact-page-back" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#028CF8] mb-6 transition-colors">
        <ArrowLeft className="h-4 w-4" /> {t("legal.backHome")}
      </Link>
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">{t("legal.contactTitle")}</h1>
      <p className="text-sm text-slate-600 leading-relaxed mb-6">{t("legal.contactSubtitle")}</p>

      <div className="bg-slate-50 border border-slate-100 rounded-2xl p-5 flex items-center gap-3 mb-6">
        <Mail className="h-5 w-5 text-[#028CF8] flex-shrink-0" />
        <a data-testid="contact-email-link" href={`mailto:${cfg?.legal_contact_email || ""}`} className="text-sm font-medium text-slate-900 break-all">
          {cfg?.legal_contact_email || "…"}
        </a>
      </div>

      {cfg && (cfg.legal_entity_name?.includes("PENDIENTES") || !cfg.legal_entity_name) && (
        <p data-testid="contact-legal-placeholder" className="text-xs text-slate-400">{t("legal.legalDataPending")}</p>
      )}
    </div>
  );
}
